import { render, staticRenderFns } from "./RequisitionApproverPicker.vue?vue&type=template&id=a74fdb3a&"
import script from "./RequisitionApproverPicker.vue?vue&type=script&lang=ts&"
export * from "./RequisitionApproverPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports